import React from 'react';
import LegalLayout from '../components/Legal';
import { COMPANY, ADDRESS_FULL } from '../siteData';
import {
  LegalTitle,
  LegalUpdated,
  LegalH2,
  LegalP,
  LegalA,
} from '../components/Legal/LegalElements';

const PrivacyPage = () => {
  return (
    <LegalLayout>
      <LegalTitle>Privacy Policy</LegalTitle>
      <LegalUpdated>Last updated: June 25, 2026</LegalUpdated>

      <LegalP>
        {`This Privacy Statement explains how Cloutch LLC, which operates the Repatch service ("Repatch," "we"), collects, uses, and shares information when you use the Service, and how we handle the call data of people who contact your business through it.`}
      </LegalP>

      <LegalH2>Information we collect</LegalH2>
      <LegalP>
        {`We collect information that businesses provide when they sign up for and configure the Service, such as account and contact details and business settings. When a person contacts a business that uses the Service, we process call data on that business's behalf — including phone numbers, call recordings and transcripts, the information the caller provides, and the appointments or requests that result from the call.`}
      </LegalP>

      <LegalH2>How we use information</LegalH2>
      <LegalP>
        {`We use the information we collect to operate, maintain, and improve the Service; to answer calls and book, confirm, reschedule, or cancel appointments on behalf of the business; to send the messages described below; to provide customer support; and to comply with our legal obligations.`}
      </LegalP>

      <LegalH2>Text messaging (SMS)</LegalH2>
      <LegalP>
        {`If a business enables text messaging, the Service sends transactional SMS to the callers who contact that business — such as appointment confirmations, reschedule and cancellation notices, requested information, and missed-call follow-ups. Callers provide their mobile number and consent to receive these texts during their call to the business. Message frequency varies based on call activity, and message and data rates may apply. Recipients can reply STOP to any message to unsubscribe at any time, or HELP for assistance.`}
      </LegalP>
      <LegalP>
        {`Mobile information and SMS consent are never shared with or sold to third parties or affiliates for marketing or promotional purposes. We share mobile numbers only with the telephony providers strictly necessary to deliver the messages that have been requested. Text messaging originator opt-in data and consent are not shared with any third parties.`}
      </LegalP>

      <LegalH2>How we share information</LegalH2>
      <LegalP>
        {`We do not sell personal information, and we never sell or share SMS opt-in or consent data with third parties for their own marketing.`}
      </LegalP>
      <LegalP>
        {`We share information only as needed to provide the Service: with the businesses on whose behalf we handle calls and messages, and with the service providers (such as telephony and infrastructure providers) that are strictly necessary to deliver the Service. We may also disclose information when required by law or to protect our rights, users, or the public.`}
      </LegalP>

      <LegalH2>Data retention</LegalH2>
      <LegalP>
        {`We retain information for as long as needed to provide the Service and for the legitimate business and legal purposes described in this Statement, after which it is deleted or de-identified.`}
      </LegalP>

      <LegalH2>Security</LegalH2>
      <LegalP>
        {`We use reasonable administrative, technical, and physical safeguards designed to protect the information we process against unauthorized access, use, or disclosure.`}
      </LegalP>

      <LegalH2>Your choices</LegalH2>
      <LegalP>
        {`Recipients of our text messages can reply STOP at any time to unsubscribe and HELP for assistance. You may contact us at the address below to ask about the information we hold and your privacy choices.`}
      </LegalP>

      <LegalH2>Contact us</LegalH2>
      <LegalP>
        {`This Service is operated by ${COMPANY.legalName}. If you have questions about this Privacy Policy, contact us at `}
        <LegalA href={`mailto:${COMPANY.email}`}>{COMPANY.email}</LegalA>
        {` or by mail at ${ADDRESS_FULL}.`}
      </LegalP>
    </LegalLayout>
  );
};

export default PrivacyPage;
